import api from "../services/apiService";

// Fetch head accounts
export const fetchHeadAccounts = async () => {
  const { data } = await api.get("/fetch-head-accounts");
  return data;
};

/**
 * Fetch filtered users
 */
export const fetchFilteredUsers = async ({
  filters,
  page = 1,
  limit = 100,
}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  params.append("categoryId", filters.category);

  filters.location.forEach((loc) => params.append("location", loc));
  filters.email.forEach((email) => params.append("email", email));
  filters.jobTitle.forEach((title) => params.append("title", title));
  filters.industry.forEach((ind) => params.append("industry", ind));
  filters.headAccount.forEach((fte) => params.append("fte", fte));
  filters.linkedin.forEach((link) => params.append("linkedin", link));
  filters.companyName.forEach((c) => params.append("companyName", c));

  const { data } = await api.get(`/filter?${params.toString()}`);
  return data;
};

/**
 * Delete database record
 */
export const deleteDatabaseRecord = async (id) => {
  return api.delete(`/delete-database/${id}`);
};

/**
 * Export database
 */
export const exportDatabase = async (filters) => {
  const params = new URLSearchParams();
  params.append("categoryId", filters.category);

  filters.location.forEach((loc) => params.append("location", loc));
  filters.jobTitle.forEach((title) => params.append("jobTitle", title));
  filters.industry.forEach((ind) => params.append("industry", ind));
  filters.headAccount.forEach((fte) => params.append("headAccountId", fte));
  filters.email.forEach((email) => params.append("email", email));
  filters.linkedin.forEach((link) => params.append("linkedin", link));
  filters.companyName.forEach((c) => params.append("companyName", c));

  return api.get(`/databases/export?${params}`, {
    responseType: "blob",
  });
};

// Import records (CSV / Excel)
export const importDatabaseRecords = async (file, mappedColumns) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("mapping", JSON.stringify(mappedColumns));

  const { data } = await api.post("/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};
